import {
  CalendarClock,
  PackageOpen,
  Truck,
  Wrench,
  type LucideIcon,
} from "lucide-react";
import { forwardRef } from "react";

type TrustTileProps = {
  icon: LucideIcon;
  title: string;
  description: string;
};

const TRUST_TILES: TrustTileProps[] = [
  {
    icon: CalendarClock,
    title: "6 months to decide",
    description:
      "Live with Matic. If you don't love it, return for a full refund.",
  },
  {
    icon: PackageOpen,
    title: "Free shipping & returns",
    description: "Both ways, in the contiguous U.S.",
  },
  {
    icon: Truck,
    title: "Ships in 2 weeks",
    description: "Your Matic ships from our California facility.",
  },
  {
    icon: Wrench,
    title: "Weekly software updates",
    description: "Matic gets smarter after it arrives.",
  },
];

const TrustTile = ({ icon: Icon, title, description }: TrustTileProps) => {
  return (
    <div className="flex min-w-0 flex-col">
      <div className="flex items-start gap-2">
        <div className="mt-px shrink-0">
          <Icon
            className="size-4 text-[#8d8b84]"
            strokeWidth={1}
            aria-hidden="true"
          />
        </div>
        <span className="font-ppMori text-[14px] leading-[1.6] tracking-[-0.28px] text-[#54524e]">
          {title}
        </span>
      </div>
      <p className="pt-[2px] font-ppMori text-[12px] leading-[1.6] tracking-[-0.24px] text-[#54524e]">
        {description}
      </p>
    </div>
  );
};

const TrustGrid = forwardRef<HTMLDivElement>(function TrustGrid(_, ref) {
  return (
    <div
      ref={ref}
      className="border-t border-legacy-neutral bg-[#faf9f7] px-[36px] py-[24px] md:px-[48px] md:pb-[16px] md:pt-[24px]"
    >
      <div className="grid grid-cols-2 gap-x-9 gap-y-[16px]">
        {TRUST_TILES.map((tile) => (
          <TrustTile key={tile.title} {...tile} />
        ))}
      </div>
    </div>
  );
});

export default TrustGrid;
